module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0076.jpg?v=e7308aaf";